import { Component, EventEmitter, OnInit, Output } from '@angular/core'

@Component({
  standalone: false,
  selector: 'vs-role-matrix',
  templateUrl: './role-matrix.component.html',
  styleUrls: ['./role-matrix.component.scss'],
})
export class RoleMatrixComponent implements OnInit {
  constructor() {}

  @Output() closeRolesMatrixEvent = new EventEmitter()

  ngOnInit(): void {}

  closeRolesMatrixOverlay() {
    this.closeRolesMatrixEvent.emit('close')
  }
}
